import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const TextBlockConfigSchema = z.object({ text: z.string().max(2_500_000) });
export type TextBlockConfig = z.infer<typeof TextBlockConfigSchema>;

export const TextBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Text),
  config: TextBlockConfigSchema,
});

export type TextBlock = z.infer<typeof TextBlockSchema>;
